import { Modal } from "antd";
import { FC, useId } from "react";

import BaseButton from "@/components/BaseButton";
import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";

import { StyledCOMConfirmButton } from "./Styled";

interface IConfirmOrderModal {
    isModalOpened: boolean;
    isProcessing: boolean;
    isChosenOrder: boolean;
    handleCloseOrder: () => void;
    handleCancel: () => void;
}

export const ConfirmOrderModal: FC<IConfirmOrderModal> = ({
    isModalOpened,
    isProcessing,
    isChosenOrder,
    handleCloseOrder,
    handleCancel,
}) => {
    const modalKey = useId();
    return (
        <Modal
            key={modalKey}
            title=""
            open={isModalOpened}
            onOk={handleCancel}
            onCancel={handleCancel}
            centered
            footer={[]}
        >
            <PrimaryText
                fontSize={20}
                lineHeight="24px"
                fontWeight="500"
                textAlign="center"
                padding="0 0 16px 0"
            >
                Ви впевнені?
            </PrimaryText>
            <SecondaryText
                fontSize={14}
                fontWeight="400"
                lineHeight="16px"
                padding="0 0 16px 0"
                textAlign="left"
            >
                Підтвердження оформить замовлення по всім обраним магазинам.
            </SecondaryText>
            <StyledCOMConfirmButton
                disabled={!isChosenOrder || isProcessing}
                loading={isProcessing}
                type="primary"
                onClick={handleCloseOrder}
            >
                Оформити замовлення
            </StyledCOMConfirmButton>
            <BaseButton type="default" onClick={handleCancel} marginTop="16px">
                Повернутися назад
            </BaseButton>
        </Modal>
    );
};
